<template>
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.26923" cy="1.26923" r="1.26923" fill="#417CE9" />
    <circle cx="1.26923" cy="12.3474" r="1.26923" fill="#417CE9" />
    <circle cx="1.26923" cy="6.80829" r="1.26923" fill="#417CE9" />
    <circle cx="5.80732" cy="1.26923" r="1.26923" fill="#417CE9" />
    <circle cx="5.80732" cy="12.3474" r="1.26923" fill="#417CE9" />
    <circle cx="5.80732" cy="6.80829" r="1.26923" fill="#417CE9" />
  </svg>
</template>
<style lang="scss" scoped>
.icon-list-dot {
  svg {
    width: 0.506rem;
    height: 0.973rem;
  }
}
</style>
